module.exports = __webpack_public_path__ + "img/44.11d16b5b.png";